import { IQuotationData, IQuotationItem } from "./quotationData.model";

export enum ILeadSource {
  Own = "Own",
  Walkin = "Walk In",
  Reference = "Reference",
  SocailMedia = "Social Media",
  Internet = "Internet Search",
}
export enum ISourceType {
  Hot = "Hot",
  Cold = "Cold",
  Warm = "Warm",
}

export enum ICategory {
  Epc = "Epc",
  Trader = "Trader",
  Distributor = "Distributor",
}

export interface IAddress {
  line1: string;
  state: string;
  pincode: string;
  city: string;
  district?: string;
}

export interface IColumn {
  id: string;
  name: string;
  cards: ILeadData[];
  isVisible: boolean;
}

export interface IStateDistrict {
  state: string;
  districts: string[];
  city: string[];
}
interface ISalesRepData {
  _id?: string;
  companyName?: string;
}

export interface ILeadData {
  showToBDE: any;
  salesRepId?: ISalesRepData;
  card: Object;
  _id?: string;
  index?: number;
  status?: string;
  name: string;
  source?: ILeadSource;
  type?: ISourceType;
  mobileNumber: string;
  whatsappNumber?: string;
  email?: string;
  address: IAddress;
  contactPersonName: string;
  showToTelecaller?: boolean;
  category?: ICategory;
  requirements: string;
  assignee?: ILeadUser;
  author?: ILeadUser;
  manager?: ILeadUser;
  quotation?: IQuotationData;
  createdAt?: string;
  createdBy?: ILeadUser;
  items?: IQuotationItem[];
  quotationNumber?: string;
  transportPrice?: number;
  gstin?: string;

  sameAsBilling?: boolean;
  meetingDone?: boolean;
  remarks?: IRemark[];
  followUpCount?: number;
}

export interface ILeadUpdateData {
  status?: string;
  showToBDE?: boolean;
  agreedToMeet?: boolean;
  skipTelecallerLead?: boolean;
}

export interface IRemark {
  lastCallDateBde?: Date;
  userId: string;
  username: string;
  index: number;
  text: string;
  createdAt: string;
}

export interface ITelecaller {
  _id: string;
  username: string;
  states: string[];
  districts: string[];
  leadLogCount: number;
}

export interface IDataEntryLeadCount {
  userId: string;
  username: string;
  count: number;
}

export interface IRoles {
  userBasedOnRoles: ILeadUser[];
  manager?: ILeadUser;
}

export interface ILeadUser {
  _id: string;
  username: string;
  manager?: ILeadUser;
  mobileNumber?: string;
  states?: string[];
  districts?: string[];
}

export interface ColumnPreference {
  columnId: string;
  isVisible: boolean;
}

export interface GetBoardResponse {
  columns: any[];
  columnPreferences: ColumnPreference[];
}

export default ILeadData;
